import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography, MenuItem, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from '../../axiosInstance';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';

const AddBookPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    bookTitle: '',
    bookDescription: '',
    authorName: '',
    publisherName: '',
    publicationYear: '',
    publisherEdition: '',
    ISBN: '',
    bookType: '',
    bookLanguage: '',
    coverImageURL: '',
    pdfURL: '',
    courseId: '',
    subjectId: '',
    semester: ''
  });

  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const semesters = [1, 2, 3, 4, 5, 6, 7, 8];

  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    axios.get('https://backend.scholarkart.in/api/courses').then((res) => setCourses(res.data));
  }, []);

  useEffect(() => {
    if (formData.courseId) {
      axios.get(`https://backend.scholarkart.in/api/subjects?courseId=${formData.courseId}`).then((res) => setSubjects(res.data));
    } else {
      setSubjects([]);
    }
  }, [formData.courseId]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileUpload = async (file, type) => {
    try {
      const res = await axios.post(`https://backend.scholarkart.in/api/upload-url?type=${type}`, { fileName: file.name });
      await axios.put(res.data.uploadUrl, file, {
        headers: { 'Content-Type': file.type }
      });
      return res.data.fileUrl;
    } catch (err) {
      console.error('File upload failed:', err);
      alert('File upload failed');
      return '';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Minimal validation
    if (!formData.bookTitle || !formData.authorName || !formData.bookType || !formData.bookLanguage) {
      alert('Please fill all required fields.');
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const bookPayload = {
        ...formData,
        courseDetails: {
          courseId: formData.courseId,
          subjectId: formData.subjectId,
          semester: formData.semester
        }
      };
      delete bookPayload.courseId;
      delete bookPayload.subjectId;
      delete bookPayload.semester;

      await axios.post('https://backend.scholarkart.in/api/books', { ...bookPayload, collegeId: user.collegeId });
      navigate('/librarymanagement');
    } catch (error) {
      console.error('Error adding book:', error);
      alert('Failed to add book');
    }
  };

  const handleSearchBook = async (query) => {
    try {
      if (!query) {
        setSearchResults([]);
        return;
      }

      const user = JSON.parse(localStorage.getItem('user'));
      const token = localStorage.getItem('token');

      const response = await axios.get('https://backend.scholarkart.in/api/books/search-global', {
        params: { query, collegeId: user.collegeId },
        headers: { Authorization: `Bearer ${token}` }
      });

      setSearchResults(response.data || []);
    } catch (err) {
      console.error('Search error:', err);
    }
  };

  const handleAddToLibrary = async (bookId) => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      await axios.post('https://backend.scholarkart.in/api/books/map-to-college', { bookId, collegeId: user.collegeId });
      alert('Book added to your library!');
      setSearchQuery('');
      setSearchResults([]);
      navigate('/librarymanagement');
    } catch (err) {
      console.error('Add to library error:', err);
    }
  };

  return (
    <main className="flex-grow p-1">
      <div className="flex justify-between items-center bg-white p-4 rounded-lg shadow-md">
        <div className="w-full max-w-lg" />
        <div className="flex items-center space-x-4">
          <Notification />
          <Profile />
        </div>
      </div>

      <Box p={4}>
        <Typography variant="h4" mb={4}>Search and Add Existing Book</Typography>

        <TextField
          label="Search from book collection"
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            handleSearchBook(e.target.value);
          }}
          fullWidth
          sx={{ mb: 3 }}
        />
        {searchResults.length > 0 && (
          <Box mb={4}>
            {searchResults.map((book) => (
              <Box key={book._id} p={2} mb={1} border="1px solid #ccc" borderRadius={2}>
                <Typography><strong>{book.bookTitle}</strong> by {book.authorName}</Typography>
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mt: 1 }}
                  onClick={() => handleAddToLibrary(book._id)}
                >
                  Add to My Library
                </Button>
              </Box>
            ))}
          </Box>
        )}


      </Box>
    </main>
  );
};

export default AddBookPage;
